import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { OptionId } from '../../../../../../../models/itinerary';
import { AppState } from '../../../../../../../store/model';
import { getProviderNames } from '../../../../../../../store/reducers/segment-options/selectors';
import { commaSeparated } from '../../../../../../../utils/helpers';
import { CarProviderDetails } from '../../../../../../lab/ProviderDetails/CarProviderDetails';
import { isSaviSelectIntl } from '../../../../../../../store/reducers/itinerary/selectors';
import { getACarDetailsForSaviSelectIntl } from '../../../../../../../store/reducers/itinerary/saviSelectIntlSelector';

interface OwnProps {
  optionId: OptionId;
  segmentId: number;
}

interface StateProps {
  /**
   * @example
   * "Hertz Corporation"
   */
  providerName: string;
  carCategory?: string;
}

interface CarProviderDetailsProps extends StateProps {}

const mapStateToProps = (
  state: AppState,
  { optionId, segmentId }: OwnProps,
) => {
  if(!isSaviSelectIntl(state)) {
    return {
      providerName: commaSeparated(getProviderNames(segmentId, optionId)(state)),
    };
  }
  else {
    const car = getACarDetailsForSaviSelectIntl(segmentId, Number(optionId))(state);
    return {
      providerName: commaSeparated([car!.providerName]),
      carCategory: car!.carCategory,
    };
  }
};

const enhance = compose<CarProviderDetailsProps, OwnProps>(
  connect(mapStateToProps),
);

/**
 * Car provider details (Container)
 *
 * @example
 * "Hertz Corporation"
 */
export const CarProviderDetailsContainer = enhance(CarProviderDetails);

CarProviderDetailsContainer.displayName = 'CarProviderDetailsContainer';
